import type { ScenarioReadStatus } from '../domain/types';
export function ScenarioReadState({
  status,
  message,
}: {
  readonly status: ScenarioReadStatus | 'EMPTY_FILTER_RESULT';
  readonly message: string;
}) {
  return (
    <section className="scc-state" role="status" data-read-status={status}>
      <h2>{status}</h2>
      <p>{message}</p>
    </section>
  );
}
